import { render } from "./ConocenosView.vue?vue&type=template&id=d4d58316"
import script from "./ConocenosView.vue?vue&type=script&lang=js"
export * from "./ConocenosView.vue?vue&type=script&lang=js"

import "./ConocenosView.vue?vue&type=style&index=0&id=d4d58316&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__